import React from 'react';
import css from './SectionSchoolHero.module.css';
import classNames from 'classnames';
import Slider from 'react-slick';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';
import campaignImg1 from '../../../../assets/sport-img1.png';
import { Icons } from '../../../../components';

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2200,
  speed: 500,
  cssEase: 'ease',
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const SocialMediaFeeds = ({ isMobileLayout }) => {
  return (
    <div className={classNames(css.postedContentSection, css.howItWorks)}>
      <div className={css.sectionHead}>
        <div className={css.leftSec}>
          <h2>Social Media Feeds</h2>
        </div>
      </div>
      <div className={css.sectionContent}>
        <div className={css.featuredListingsContent}>
          <div className={css.templatesSlider}>
            <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
              <div className={css.block}>
                <div className={css.blockUserInfo}>
                  <div className={css.blockUserImg}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.blockUserInfo}>
                    <div className={css.blockInfoLeft}>
                      <h3>Bill Catch</h3>
                      <p>12 April at 09:28 PM</p>
                    </div>
                    <div className={css.blockInfoRight}>
                      <span className={css.menuIcon}>
                        <Icons name="menuVertical" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className={css.description}>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat tempore fugiat
                  doloremque doloribus quibusdam nihil ea temporibus eos architecto, nulla, sunt
                  commodi laboriosam aperiam eaque maiores libero voluptates fuga consequuntur!
                </div>
                <div className={css.imagesGridSec}>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                </div>
              </div>
              <div className={css.block}>
                <div className={css.blockUserInfo}>
                  <div className={css.blockUserImg}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.blockUserInfo}>
                    <div className={css.blockInfoLeft}>
                      <h3>Bill Catch</h3>
                      <p>12 April at 09:28 PM</p>
                    </div>
                    <div className={css.blockInfoRight}>
                      <span className={css.menuIcon}>
                        <Icons name="menuVertical" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className={css.description}>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat tempore fugiat
                  doloremque doloribus quibusdam nihil ea temporibus eos architecto, nulla, sunt
                  commodi laboriosam aperiam eaque maiores libero voluptates fuga consequuntur!
                </div>
                <div className={css.imagesGridSec}>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                </div>
              </div>
              <div className={css.block}>
                <div className={css.blockUserInfo}>
                  <div className={css.blockUserImg}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.blockUserInfo}>
                    <div className={css.blockInfoLeft}>
                      <h3>Bill Catch</h3>
                      <p>12 April at 09:28 PM</p>
                    </div>
                    <div className={css.blockInfoRight}>
                      <span className={css.menuIcon}>
                        <Icons name="menuVertical" />
                      </span>
                    </div>
                  </div>
                </div>
                <div className={css.description}>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat tempore fugiat
                  doloremque doloribus quibusdam nihil ea temporibus eos architecto, nulla, sunt
                  commodi laboriosam aperiam eaque maiores libero voluptates fuga consequuntur!
                </div>
                <div className={css.imagesGridSec}>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.itemWrapper}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaFeeds;
